// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import styled from "styled-components";

const Heading = styled.h3`
  width: 100%;
  margin-top: 6px;
  margin-bottom: 0;
  padding: 4px 10px;
  color: #828282;
  background: #f2f2f2;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'title' implicitly has an 'any' type.
export function TimeSheetHeading({ title }) {
  return <Heading>{title}</Heading>;
}
